$ = require 'jquery'
Invitation = require 'models/invitation'
PopOver = require 'views/lib/pop-over'
SelectMemberRoleView = require 'views/member/select-member-role-view'
Util = require 'lib/util'
track = require 'debug/track'

module.exports = class SelectNewMemberRoleView extends SelectMemberRoleView

  invite: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-invite')

    type = if $target.hasClass('js-select-admin')
      'admin'
    else if $target.hasClass('js-select-member')
      'normal'
    else if $target.hasClass('js-select-observer')
      'observer'

    Invitation::create.call @,
      model: @parent
      data: { type, email: @options.email }
      success: (data) =>
        track("Invitations", "Send Email #{@objText} Invite to New Member", "Role: #{type}")

    PopOver.popView()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/select-new-member-role-view.coffee